import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import uiReducer from './features/uiSlice';
import alertReducer from './features/alertSlice';
import reviewReducer from './features/reviewSlice';
import claimProjectReportsReducer from './features/claimProjectReportsSlice';
import companiesReducer from './features/companiesSlice';
import toastReducer from './features/toastSlice';
import navbarBreadcrumbReducer from './features/navbarBreadcrumbSlice';
export default configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    alerts: alertReducer,
    review: reviewReducer,
    claimProjectReports: claimProjectReportsReducer,
    companies: companiesReducer,
    toast: toastReducer,
    navbarBreadcrumb: navbarBreadcrumbReducer
  }
});